import ConversationServices from "@/services/conversation";

const state = {
    conversations: [],
    maxTotalConversations: 1,
    isFetchingNextPage: false,
    hasUnread: false
};
const mutations = {
    updateConversations(state, payload) {
        state.conversations = payload;
    },
    updateTotal(state, value) {
        state.maxTotalConversations = value;
    },
    showFetchingPageLoader(state, value) {
        state.isFetchingNextPage = value;
    },
    setHasUnread(state, value) {
        state.hasUnread = value;
    }
};
const actions = {
    removeConversationFromList({ state, commit }, payload = {}) {
        let newConversationList = state.conversations.filter(
            record => record.client_id !== payload.id
        );

        commit("updateConversations", newConversationList);
    },
    async clearAllConversation({ commit }) {
        commit("updateConversations", []); // clear list
    },
    async getUnread({ commit }) {
        let unread = await ConversationServices.getUnread();
        let hasUnread = unread && unread.length > 0;
        commit("setHasUnread", hasUnread);
    },
    async getConversations({ state, commit }, payload = {}) {
        let page = payload.page || 1;

        commit("showFetchingPageLoader", true);
        let conversations = (await ConversationServices.all(page)).resources;
        commit("showFetchingPageLoader", false);

        if (page === 1) {
            commit("updateConversations", conversations.data || []);
            commit("updateTotal", conversations.total);
        } else {
            // append
            commit("updateConversations", [
                ...state.conversations,
                ...conversations.data
            ]);
        }

        return conversations;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
